// src/pages/intranet/pages/Login.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 

export default function Login() {
  const [dni, setDni] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (dni.trim() === '' || password.trim() === '') {
      alert('Por favor, completa todos los campos.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://logia-production-725b.up.railway.app/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dni, password }) 
      });

      const data = await response.json();

      if (data.success) {
        // Enviar el objeto completo que viene del servidor
        login(data.user);
        
        // Si el rol es ADMIN, lo dirigimos directo a su panel
        if (data.user.role === 'ADMIN') {
          navigate('/intranet/admin');
        } else {
          navigate('/intranet/inicio');
        }
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error de login:", error);
      alert('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col justify-center items-center relative overflow-hidden font-sans selection:bg-[#C5A059] selection:text-[#050505]">
      
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay pointer-events-none"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#050505] via-[#050505]/95 to-[#111111] z-0 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-md px-6 animate-fade-in">
        
        <div className="text-center mb-10">
          <span className="text-[#C5A059] text-[10px] tracking-[0.4em] uppercase block mb-4 font-semibold">
            Gran Logia del Perú
          </span>
          <h1 className="font-serif text-4xl md:text-5xl text-white font-normal tracking-tight mb-2">
            Intranet
          </h1>
          <div className="w-12 h-[1px] bg-[#C5A059] mx-auto mt-6 mb-4"></div>
          <p className="text-gray-400 font-light text-xs md:text-sm tracking-[0.2em] uppercase">
            Acceso Administrativo
          </p>
        </div>

        <div className="bg-[#0a0a0a] border border-white/10 p-8 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C5A059] to-transparent opacity-50"></div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            
            {/* Input DNI */}
            <div>
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">
                Documento de Identidad (DNI)
              </label>
              <input 
                type="text" 
                placeholder="Ingresa tu DNI"
                value={dni}
                onChange={(e) => setDni(e.target.value)}
                className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors placeholder-gray-700 font-light text-sm"
                required
              />
            </div>

            {/* Input Contraseña */}
            <div>
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">
                Contraseña de Acceso
              </label>
              <input 
                type="password" 
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors placeholder-gray-700 font-light text-sm"
                required
              />
            </div>

            <button 
              type="submit" 
              disabled={loading}
              className="w-full mt-4 bg-[#C5A059] hover:bg-white text-[#050505] font-semibold text-xs tracking-[0.2em] uppercase py-4 transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? 'Verificando...' : 'Ingresar al Portal'}
            </button>
          </form>
        </div>
        
        <div className="text-center mt-8">
           <p className="text-gray-600 text-[10px] tracking-[0.2em] uppercase font-mono">
             Uso exclusivo para miembros regulares
           </p>
        </div>

      </div>
    </div>
  );
}